module.exports = __webpack_public_path__ + "img/weight.c6b21189.svg";